module.exports = __webpack_public_path__ + "img/beloc_banner_2022-01.b8459b53.jpg";